import axios from 'axios';
import {
  GET_LOTTERY_DRAWS_REQUEST,
  GET_LOTTERY_DRAWS_SUCCESS,
  GET_LOTTERY_DRAWS_FAILURE,
  GET_LOTTERY_DRAW_ACTIVE_REQUEST,
  GET_LOTTERY_DRAW_ACTIVE_SUCCESS,
  GET_LOTTERY_DRAW_ACTIVE_FAILURE
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getLotteryResultDraws = (isSuper, isQueryPage = false) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_LOTTERY_DRAWS_REQUEST
    });

    const apiBase = isSuper ? 'super-lottery' : 'lottery';

    let res = await axios({
      url: `${API_GATEWAY}/mobile/${apiBase}/draw?status=CLOSED`,
      method: 'get'
    });

    const modifiedResponse = {
      ...res.data,
      draws: res.data?.draws?.reverse()
    };

    dispatch({
      type: GET_LOTTERY_DRAWS_SUCCESS,
      payload: modifiedResponse
    });

    
    if (!isQueryPage) {
      dispatch(getLotteryResultDrawActive(modifiedResponse.draws[0]?.drawNumber, isSuper));
    }

  } catch (e) {

    dispatch({
      type: GET_LOTTERY_DRAWS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getLotteryResultDrawActive = (drawNumber, isSuper = false) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_LOTTERY_DRAW_ACTIVE_REQUEST
    });

    const apiBase = isSuper ? 'super-lottery' : 'lottery';

    const res = await axios({
      url: `${API_GATEWAY}/mobile/${apiBase}/public/draw/${drawNumber}/result`,
      method: 'get'
    });

    dispatch({
      type: GET_LOTTERY_DRAW_ACTIVE_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: GET_LOTTERY_DRAW_ACTIVE_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};
